<h1 mat-dialog-title>Confirm products {{Error}}</h1>
<div mat-dialog-content class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormularioConfirmar">
    <mat-form-field class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <mat-label>Quantity {{data.Quantity}}</mat-label>
        <input matInput  formControlName="Quantity" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"/>
      </mat-form-field>
      
      <mat-form-field  appearance="fill"
		  class="col-xs-6 col-sm-3 col-md-6 col-lg-6 col-xl-6 col-xxl-6 InputSty">
			<mat-label>Search Location</mat-label>
			<input matInput (keyup)="applyFilterLocation($event)" #input />
		   
			<mat-hint>Filter Location</mat-hint>
		  </mat-form-field>
      <mat-form-field appearance="fill" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
        <mat-label>Select location</mat-label>
        <mat-select formControlName="location" #locations>
          <mat-option *ngFor="let item of ArrayLocations" [value]="item.id">Location: {{ item.location }} - Description: {{ item.locationDescription }}</mat-option>
        </mat-select>
      </mat-form-field>
      
  </div>
</div>
<div mat-dialog-actions>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
  <button  mat-raised-button
  color="danger" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="onNoClick()">Cancel</button>
</div>
<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
  <button  mat-raised-button
  color="primary" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnConfirmar()">Confirm</button>
</div>
  </div>
  
  
</div>
